/**
 * Financial Options component
 * Handles the Svea part payment calculator widget updates on variant changes
 */
class FinancialOptions extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.dataset.variantId;
  }

  /**
   * Updates the Svea payment calculator price when variant changes
   * @param {number} newPrice - The new price in cents
   */
  updatePrice(newPrice) {
    const sveaCalculator = this.querySelector('.svea-pp-widget-part-payment');
    if (sveaCalculator) {
      // Dispatch the Svea custom event to update the calculator price
      // Price should be in euros (divide by 100 to convert from cents)
      document.dispatchEvent(new CustomEvent('svea-partpayment-calculator-update-price', {
        detail: {
          price: `${newPrice / 100}`
        }
      }));
    }
  }

  /**
   * Updates availability state based on variant availability
   * @param {boolean} isAvailable - Whether the current variant is available
   */
  updateAvailability(isAvailable) {
    if (isAvailable) {
      this.setAttribute('available', '');
    } else {
      this.removeAttribute('available');
    }
  }

  /**
   * Updates the variant ID data attribute
   * @param {string} variantId - The new variant ID
   */
  updateVariantId(variantId) {
    this.variantId = variantId;
    this.dataset.variantId = variantId;
  }
}

customElements.define('financial-options', FinancialOptions);
